"use strict";
/**
 * Priority Queue implementation based on one by "gyre" from stack overflow:
 * https://stackoverflow.com/a/42919752
 * license: https://creativecommons.org/licenses/by-sa/3.0/
 * copyright:
 * - gyre https://stackoverflow.com/users/7256039/gyre
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityQueue = void 0;
const top = 0;
const parent = (i) => ((i + 1) >>> 1) - 1;
const left = (i) => (i << 1) + 1;
const right = (i) => (i + 1) << 1;
class PriorityQueue {
    /**
     *
     * @param comparator Determines if a has higher priority than b
     */
    constructor(comparator) {
        this.heap = [];
        this.isHigherPriority = comparator;
    }
    /**
     *
     */
    size() {
        return this.heap.length;
    }
    isEmpty() {
        return this.size() == 0;
    }
    /**
     * Reveals the highest priority item without removal
     */
    peek() {
        return this.heap[top];
    }
    enqueue(...values) {
        values.forEach((value) => {
            this.heap.push(value);
            this.siftUp();
        });
        return this.size();
    }
    remove(v) {
        const index = this.heap.indexOf(v);
        if (index < 0) {
            return false;
        }
        // Remove the target element
        this.heap = this.heap.splice(index, 1);
        return true;
    }
    find(f) {
        return this.heap.find(f);
    }
    /**
     * Removes the highest priority item (as defined by the comparator)
     */
    dequeue() {
        const poppedValue = this.peek();
        const bottom = this.size() - 1;
        if (bottom > top) {
            this.swap(top, bottom);
        }
        this.heap.pop();
        this.siftDown();
        return poppedValue;
    }
    /**
     * Remove all items with priority higher than the priority given
     */
    dequeueUntil(v) {
        const values = [];
        let peeked;
        while ((peeked = this.peek()) && this.isHigherPriority(peeked, v)) {
            this.dequeue();
            values.push(peeked);
        }
        return values;
    }
    greater(i, j) {
        return this.isHigherPriority(this.heap[i], this.heap[j]);
    }
    swap(i, j) {
        [this.heap[i], this.heap[j]] = [this.heap[j], this.heap[i]];
    }
    siftUp() {
        let node = this.size() - 1;
        while (node > top && this.greater(node, parent(node))) {
            this.swap(node, parent(node));
            node = parent(node);
        }
    }
    siftDown() {
        let node = top;
        while ((left(node) < this.size() && this.greater(left(node), node)) ||
            (right(node) < this.size() && this.greater(right(node), node))) {
            let maxChild = right(node) < this.size() && this.greater(right(node), left(node))
                ? right(node)
                : left(node);
            this.swap(node, maxChild);
            node = maxChild;
        }
    }
    observe() {
        return {}; // TODO: add observe information
    }
}
exports.PriorityQueue = PriorityQueue;
//# sourceMappingURL=PriorityQueue.js.map